
import { defineComponent, computed } from "vue";

const __default__ = defineComponent({
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    starWitdh: {
      type: String,
      default: "40px"
    },
    showNumber: {
      type: Boolean,
      default: false
    },
    numberLabel: {
      type: [Number, String],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const onInput = async (event: Event) => {
      const input = event.target as HTMLInputElement;
      emit("update:modelValue", parseInt(input.value));
    };
    const displayNumber = computed(() =>
      String(props.numberLabel || props.value)
    );
    return { onInput, displayNumber };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "3bc9f3f1": (_ctx.starWitdh)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__